import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiAward, FiUsers, FiTrendingUp } = FiIcons;

const features = [
  {
    icon: FiShield,
    title: "Exclusive Employer Representation",
    description: "We NEVER represent employees. Our loyalty is 100% with California business owners, ensuring no conflicts of interest."
  },
  {
    icon: FiAward,
    title: "30+ Years of Experience",
    description: "Three decades of successfully defending California businesses against employment law claims and regulatory challenges."
  },
  {
    icon: FiUsers,
    title: "Trusted Legal Advocacy",
    description: "Aggressive representation that puts your business interests first. We fight hard against frivolous claims and overreaching regulations."
  },
  {
    icon: FiTrendingUp,
    title: "Tailored Business Solutions",
    description: "Custom legal strategies designed specifically for your business needs and industry challenges in California's complex legal landscape."
  }
];

const FeatureShowcase = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Why California Businesses Choose Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We aggressively defend your business against unfair labor laws and frivolous employee claims. 
            Our exclusive focus on employers means we fight solely for your interests.
          </p>
        </motion.div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center group"
            >
              <div className="bg-blue-100 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-200 transition-colors">
                <SafeIcon icon={feature.icon} className="text-2xl text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureShowcase;